// Markdownから描画する <img> に loading="lazy" を付与し、画面外の画像は読み込みを遅らせる。
// 画像1枚ごとにRails(Cloud Run)を経由するため、画像の多いページで初期表示の同時リクエストを減らす狙いがある。
// 保存済みのMarkdownには属性がないので、保存時のテンプレートではなく描画時に付与している。

const IMG_TAG_PATTERN = /<img(?=[\s/>])[^>]*>/gi
const LOADING_ATTRIBUTE_PATTERN = /\sloading\s*=/i
const LAZY_ATTRIBUTES = 'loading="lazy" decoding="async"'

// 記法の画像(image)と、生HTMLで書かれた画像(html_inline / html_block)の両方が対象
const TARGET_RULE_NAMES = ['image', 'html_inline', 'html_block']

function addLazyAttributes(html) {
  return html.replace(IMG_TAG_PATTERN, (tag) => {
    // 利用者が loading を明示している場合は、その指定を尊重する
    if (LOADING_ATTRIBUTE_PATTERN.test(tag)) return tag

    return tag.replace(/^<img/i, `<img ${LAZY_ATTRIBUTES}`)
  })
}

// 他のプラグインが描画したHTMLも書き換えるため、md.use の最後に登録すること
// (markdown-it-video-initializer は元のルールを呼ばずに html_inline を上書きする)
export default function (md) {
  TARGET_RULE_NAMES.forEach((ruleName) => {
    const defaultRender = md.renderer.rules[ruleName]

    md.renderer.rules[ruleName] = function (tokens, idx, options, env, self) {
      return addLazyAttributes(defaultRender(tokens, idx, options, env, self))
    }
  })
}
